import {NoOrdersContainer, NoOrdersInfoContainer} from "./styled";
import {BarekamIcon} from "../../../components/icon/barekam-icon";
import {OrderIcons} from "../../../components/icon/variants";
import BarekamText from "../../../components/text";
import React from "react";
import Message from "../../../components/message";
import {MessageSections} from "../../../components/message/message";
import {useAppSelector} from "../../../../redux/store";

const NoOrders = ({messageKey = 'no_orders_description'}: {messageKey?: string}) => {
    const {matchesPhone} = useAppSelector(state => state.deviceReducer);

    return (
        <NoOrdersContainer>
            <NoOrdersInfoContainer>
                <BarekamIcon variant={OrderIcons.noOrders}
                             size={{width: matchesPhone ? '15rem' : '27rem',
                                    height: matchesPhone ? '5rem' : '9rem'}}/>

                <BarekamText variant={"xl"} fontWeight={600} opaque>
                    <Message messageKey={messageKey} sectionId={MessageSections.ORDERS}/>
                </BarekamText>
            </NoOrdersInfoContainer>
        </NoOrdersContainer>
    )
}

export default NoOrders;
